import chevronLeft from "@assets/images/chevron-left.svg";
import EOrderingLogo from "@assets/images/eOrdering.png";
import iconMail from "@assets/images/mail.svg";
import SCGPLogo from "@assets/images/SCGP-color.svg";
import { Button, TextField } from "@material-ui/core";
import FormSpacer from "@saleor/components/FormSpacer";
import MyTypography from "@saleor/components/MyTypography";
import { commonMessages } from "@saleor/intl";
import getAccountErrorMessage from "@saleor/utils/errors/account";
import classNames from "classnames";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import * as Yup from "yup";

import useStyles from "../styles";

export interface ResetPasswordPageFormData {
  email: string;
}
// interface IUpdateEmailPageError {
//   code: string;
//   field?: string;
//   message: string;
// }
export interface ResetPasswordPageProps {
  disabled: boolean;
  errors: any[];
  onBack: () => void;
  onSubmit: (data: ResetPasswordPageFormData) => void;
}
const ResetPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .required("Email is required")
    .email("Invalid email format ")
    .test(
      "email",
      "Please input external email",
      val => val && !val.includes("@scg.com")
    )
});
const UpdateEmailPage: React.FC<ResetPasswordPageProps> = props => {
  const { disabled, errors, onBack, onSubmit } = props;
  const [errorEmail, setErrorEmail] = useState("");
  const formik = useFormik({
    initialValues: {
      email: ""
    },
    onSubmit: values => {
      onSubmit(values);
    },
    validationSchema: ResetPasswordSchema
  });
  const classes = useStyles(props);
  const intl = useIntl();

  useEffect(() => {
    const error = getAccountErrorMessage(
      errors.find(err => err.field === "email"),
      intl
    );
    if (error) {
      setErrorEmail(error);
    }
  }, [errors]);

  const error = getAccountErrorMessage(
    errors.find(err => err.field !== "email"),
    intl
  );

  useEffect(() => {
    if (errorEmail) {
      setErrorEmail("");
    }
  }, [formik.values.email]);

  return (
    <div className={classes.root}>
      <div className={classes.mainPanel}>
        <div className={classes.headTextLogo}>
          <div className={classes.text}>
            <img src={SCGPLogo} alt={"logo"} />
          </div>
          <div className={classes.logo}>
            <img src={EOrderingLogo} alt={"logo"} />
          </div>
        </div>
        <form onSubmit={formik.handleSubmit}>
          <>
            <div className={classes.mailTitle}>
              <img src={iconMail} alt="Email icon" />
              <MyTypography
                variant="h6"
                className={classes.header}
                style={{ color: "#222222 " }}
              >
                <FormattedMessage defaultMessage="กรุณาอัปเดตอีเมลของคุณ" />
              </MyTypography>
            </div>
            {!!error && <div className={classes.panel}>{error}</div>}
            <MyTypography
              variant="body3"
              color="textSecondary"
              className={classes.description}
            >
              <FormattedMessage defaultMessage="กรุณาอัปเดตอีเมล ก่อนเริ่มต้นใช้งาน เพื่อความปลอดภัย ในบัญชี และความสะดวกในการใช้งานของคุณ" />
            </MyTypography>
            <FormSpacer space={32} />
            <TextField
              autoFocus
              disabled={disabled}
              fullWidth
              label={intl.formatMessage(commonMessages.yourEmail)}
              name="email"
              onChange={formik.handleChange}
              value={formik.values.email}
              error={
                (formik.errors.email && formik.touched.email) || !!errorEmail
              }
              inputProps={{
                "data-testid": "email"
              }}
            />
            <div className={classes.textError}>
              {formik.errors.email && formik.touched.email
                ? formik.errors.email
                : ""}
            </div>
            {errorEmail && (
              <MyTypography className={classes.textError} variant="caption">
                {errorEmail}
              </MyTypography>
            )}
            <FormSpacer space={32} />
            <Button
              data-testid="submit"
              className={classNames(
                classes.typeButton,
                "gradient",
                classes.typeButtonSCG
              )}
              variant="contained"
              color="secondary"
              type="submit"
            >
              <MyTypography variant="subtitle1">
                <FormattedMessage
                  defaultMessage="ยืนยันอีเมล"
                  description="password reset, button"
                />
              </MyTypography>
            </Button>
            <FormSpacer space={30} />
            <MyTypography
              className={classes.linkBack}
              onClick={onBack}
              variant="body3"
              data-testid="login-link"
            >
              <img src={chevronLeft} alt="Back to Sign In" />
              <FormattedMessage
                defaultMessage="Back to Sign In"
                description="description"
              />
            </MyTypography>
          </>
        </form>
      </div>
    </div>
  );
};

export default UpdateEmailPage;
